import { useState, type ReactNode } from 'react'

// Collapsible panel: the title bar is a toggle. Reuses the .panel / h2 styling;
// open by default so existing layouts are unchanged until the user collapses.
export default function Panel({ title, children, defaultOpen = true }: {
    title: ReactNode
    children: ReactNode
    defaultOpen?: boolean
}) {
    const [open, setOpen] = useState(defaultOpen)
    return (
        <div className={`panel${open ? '' : ' collapsed'}`}>
            <button type="button" className="panel-head" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
                <span className="panel-chevron" aria-hidden>▾</span>
                <h2>{title}</h2>
            </button>
            {open && <div className="panel-body">{children}</div>}
        </div>
    )
}
